export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/chevron-down-7fcc68926d8ee7f8376a5452e8c978cf.svg";